import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const StyledDrawerWrapper = styled(Box, {
	'& [data-drawer-wrapper]': {
		display: 'flex',
		margin: 'unset',
		padding: 'unset',
	},
});